module.exports = __webpack_public_path__ + "img/Users.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Users.svg
// module id = 254
// module chunks = 0